import store from "@/store";
import Vue from 'vue'
import DatabaseConnector from "@/store/common/DatabaseConnector";
import App from "@/App.vue";
import LocationsStore from "@/store/modules/Locations/LocationsStore";
import FirebaseConnectionStore from "@/store/modules/FirebaseConnection/FirebaseConnectionStore";

Vue.config.productionTip = false;

(async () => {
    console.log(new Date("2020-07-02T00:03:42.594Z"));
    console.log(new Date());
    console.log(new Date("2020-07-02T00:03:42.594Z").getTime() - new Date().getTime());

    new Vue({
        store,
        render: h => h(App)
    }).$mount('#app');

    // データベース接続
    const connectResult = await DatabaseConnector.connect();
    if (connectResult.isError) {
        alert(connectResult.errorMessage);
        return;
    }

    FirebaseConnectionStore.setIsConnected(true)
    LocationsStore.startRealtimeUpdate();

})();
